import { Box, Button, Stack } from "@mui/material";
import NavbarUserDropdown from "components/navbar/NavbarUserDropdown";
import SubscriptionPaymentFailedIndicator from "components/subscriptions/SubscriptionPaymentFailedIndicator";
import { UpgradeIcon } from "components/ui/icons";
import useAccountSubscription from "hooks/useAccountSubscription";
import useAuth from "hooks/useAuth";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const SidebarMobileAccountSection = () => {
  const { isSuperuser } = useAuth();
  const { isFreePlan, stripeRenewalFailed } = useAccountSubscription();

  return (
    <Box
      sx={{
        p: 3,
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        {!isSuperuser && stripeRenewalFailed && (
          <SubscriptionPaymentFailedIndicator fullWidth />
        )}
        {!isSuperuser && !stripeRenewalFailed && isFreePlan && (
          <>
            <Button
              component={RouterLink}
              to="/plans"
              variant="contained"
              startIcon={<UpgradeIcon />}
              role="upgrade"
              fullWidth
            >
              Upgrade
            </Button>
          </>
        )}
        <NavbarUserDropdown showName fullWidth />
      </Stack>
    </Box>
  );
};

export default SidebarMobileAccountSection;
